var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSifatAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444.88 634.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradiente_sem_nome_3-2);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: url(#Gradiente_sem_nome_3);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        fill: url(#Gradiente_sem_nome_2);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-7 {\n        clip-rule: evenodd;\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m414.89.04C256.69,3.44,46.46,93.91,42.01,159.4c-3.82,56.33,112.17,74.47,146.24,104.39-2.75-3.97-3.68-8.84-1.91-14.93,8.47-29.41,141.77-68.48,217.15-88.05,11.62-3.02,29.46-12.52,33.16-35.88,4.31-27.2,6.92-88.94,8.24-105.58,0-17.58-15.91-19.34-26.9-19.34-1.08,0-2.11.02-3.08.04Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 73.08,
    y1: 159.11,
    x2: 527.9,
    y2: 85.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f67b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f3264"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m260,387.09c-8.65,29.36-142.21,67.58-217.71,86.67-11.64,2.94-29.54,12.33-33.38,35.67C4.43,536.6,1.42,598.33,0,614.95c-.13,19.32,19.07,19.66,29.86,19.5,158.22-2.4,369.03-91.52,373.89-156.98,4.18-56.31-111.69-75.18-145.57-105.32,2.73,3.98,3.63,8.86,1.82,14.94Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    "data-name": "Gradiente sem nome 2",
    x1: 372.34,
    y1: 477.25,
    x2: -82.42,
    y2: 547.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f3264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f67b2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m22.17,247.7c0,56.45,28.72,99.46,85.17,116.93l219.06,71.18c43.35,14.11,84.16,46.41,60.98,73.09,34.79-26.33,42.5-68.17,42.5-128.13,0-47.06-16.03-98.6-90.03-119.63l-214.03-66.81c-43.34-14.11-84.15-46.42-60.98-73.09-51.58,39.77-42.67,126.46-42.67,126.46Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    "data-name": "Gradiente sem nome 3",
    x1: 230.2,
    y1: 318.55,
    x2: -15.54,
    y2: 219.37,
    xlinkHref: "#Gradiente_sem_nome_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 38.19,
    y: 0,
    width: 406.7,
    height: 263.79
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -0.13,
    y: 372.14,
    width: 408.07,
    height: 262.46
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.26,
    y: 121.24,
    width: 416.63,
    height: 387.66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSifatAzul);
export default __webpack_public_path__ + "static/media/LogoSifatAzul.0b8c6f34d929c9bc5e9f0a18db815591.svg";
export { ForwardRef as ReactComponent };